import React from "react";
import SwipeableViews from "react-swipeable-views-react-18-fix";
import { Box, Typography, MobileStepper, Button } from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

export default function NotesCarousel({
  notes = [],
  emptyText = "No notes posted yet.",
  max = 10,
}) {
  const [activeStep, setActiveStep] = React.useState(0);

  const items = Array.isArray(notes) ? notes.slice(0, max) : [];
  const maxSteps = items.length;

  React.useEffect(() => {
    // if notes length changes (new note added), keep index valid
    if (activeStep > maxSteps - 1) setActiveStep(0);
  }, [maxSteps]); // eslint-disable-line

  if (!maxSteps) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: 12 }}>
        {emptyText}
      </Typography>
    );
  }

  const handleNext = () => setActiveStep((s) => Math.min(s + 1, maxSteps - 1));
  const handleBack = () => setActiveStep((s) => Math.max(s - 1, 0));

  return (
    <Box
      sx={{
        border: "1px solid #eee",
        borderRadius: 1,
        bgcolor: "#fafafa",
        overflow: "hidden",
      }}
    >
      <SwipeableViews
        index={activeStep}
        onChangeIndex={setActiveStep}
        enableMouseEvents
      >
        {items.map((n) => (
          <Box key={n._id} sx={{ p: 1.25, minHeight: 110 }}>
            <Typography variant="caption" color="text.secondary">
              {n.createdAt ? new Date(n.createdAt).toLocaleString() : ""}
            </Typography>

            <Typography
              variant="body2"
              sx={{ mt: 0.75, whiteSpace: "pre-wrap", lineHeight: 1.6 }}
            >
              {n.text}
            </Typography>
          </Box>
        ))}
      </SwipeableViews>

      <MobileStepper
        variant="dots"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        sx={{
          bgcolor: "#fff",
          borderTop: "1px solid #eee",
          "& .MuiMobileStepper-dots": { mr: 1 },
        }}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next <KeyboardArrowRight />
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            <KeyboardArrowLeft /> Back
          </Button>
        }
      />
    </Box>
  );
}
